import React from "react";
import { Linkedin, Twitter, Instagram } from "lucide-react";

const cols = [
  {
    title: "Therapeutic Areas",
    links: ["Psychiatry", "Orthopedics", "Neurology", "General Medicine"],
  },
  {
    title: "Company",
    links: ["About", "Manufacturing", "Quality", "Careers"],
  },
  {
    title: "Resources",
    links: ["Product Brochure", "Pharmacovigilance", "Media Kit", "Contact"],
  },
];

export default function Footer() {
  return (
    <footer
      data-testid="site-footer"
      className="bg-[#020617] text-slate-300 pt-24 md:pt-32 pb-10 relative overflow-hidden"
    >
      <div
        aria-hidden
        className="absolute inset-0 opacity-[0.08]"
        style={{
          backgroundImage:
            "linear-gradient(to right, rgba(255,255,255,0.2) 1px, transparent 1px), linear-gradient(to bottom, rgba(255,255,255,0.2) 1px, transparent 1px)",
          backgroundSize: "72px 72px",
        }}
      />
      <div className="max-w-7xl mx-auto px-6 md:px-12 relative">
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-12">
          <div className="lg:col-span-5">
            <a href="#top" className="inline-flex items-center" data-testid="footer-logo" aria-label="Marpay Biotec">
              <img
                src="https://customer-assets.emergentagent.com/job_marpay-pharma/artifacts/2yvkh7io_logo.png"
                alt="Marpay Biotec"
                className="h-16 w-auto object-contain"
                loading="lazy"
              />
            </a>
            <p className="mt-6 max-w-md text-slate-400 leading-relaxed">
              A new-generation Indian pharmaceutical company building evidence-based medicines
              across Psychiatry, Orthopedics, Neurology and General Medicine.
            </p>
            <div className="mt-8 flex items-center gap-3">
              {[Linkedin, Twitter, Instagram].map((Icon, i) => (
                <a
                  key={i}
                  href="#"
                  data-testid={`social-link-${i}`}
                  className="h-10 w-10 inline-flex items-center justify-center rounded-full border border-white/15 hover:bg-white hover:text-[var(--mp-text)] transition-colors"
                  aria-label="Social"
                >
                  <Icon className="h-4 w-4" />
                </a>
              ))}
            </div>
          </div>

          <div className="lg:col-span-7 grid grid-cols-2 md:grid-cols-3 gap-8">
            {cols.map((c) => (
              <div key={c.title}>
                <div className="text-xs font-mono-display tracking-[0.25em] uppercase text-slate-500 mb-5">
                  {c.title}
                </div>
                <ul className="space-y-3">
                  {c.links.map((l) => (
                    <li key={l}>
                      <a
                        href="#"
                        className="text-slate-300 hover:text-white transition-colors"
                        data-testid={`footer-link-${l.toLowerCase().replace(/\s+/g, "-")}`}
                      >
                        {l}
                      </a>
                    </li>
                  ))}
                </ul>
              </div>
            ))}
          </div>
        </div>

        <div className="mt-24 pt-10 border-t border-white/10 flex flex-col md:flex-row gap-4 md:items-center md:justify-between">
          <div className="font-display text-[clamp(3rem,12vw,12rem)] leading-none text-white/[0.06] tracking-tighter font-medium hidden md:block absolute -bottom-6 left-0 right-0 text-center select-none pointer-events-none">
            MARPAY BIOTEC
          </div>
          <p className="text-xs text-slate-500 relative">
            © {new Date().getFullYear()} Marpay Biotec LLP. All rights reserved.
          </p>
          <div className="flex items-center gap-6 text-xs text-slate-500 relative">
            <a href="#" className="hover:text-white">Privacy</a>
            <a href="#" className="hover:text-white">Terms</a>
          </div>
        </div>
      </div>
    </footer>
  );
}
